export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/price', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getPriceList = async (searchText) => {
    try {
        const result = await get(`price${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getPriceContent = async (newsId) => {
    try {
        const result = await get(`price/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createPrice = async (data) => {
    try {
        const result = await post('price', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updatePrice = async (id, data) => {
    try {
        const result = await put(`price/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deletePrice = async (id) => {
    try {
        const result = await destroy(`price/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`price/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

